module.exports = __webpack_public_path__ + "img/panelView_strong_3_1.1724c792.png";